import Vue from "vue";
import { ETollList } from "../enums/ServicesProductsEToll";

function updateLineInArray(array, line, update) {
  // We must replace whole object if we want keep reactivity and cause re-render
  const index = array.findIndex((arrayLine) => arrayLine.id === line.id);
  if (index !== -1) {
    array.splice(index, 1, {
      ...array[index],
      ...update,
    });
  }
}

function mapHistoricLineIntoOrderLine(historicLine, currencyRatio) {
  let finalPrice = (
    Number(historicLine.product[0].price) / currencyRatio
  ).toFixed(2);
  let finalLastPrice =
    historicLine.product[0].lastPrice &&
    (Number(historicLine.product[0].lastPrice) / currencyRatio).toFixed(2);
  let productObject = {
    ...historicLine.product[0],
    price: finalPrice,
    lastPrice: finalLastPrice,
  };
  return {
    ...historicLine,
    product: productObject,
    localization: historicLine.location,
    option: 1,
    discount: Number(historicLine.discount),
    deliveryDate: new Date(productObject.deliveryDate),
    basePrice: Number(historicLine.product[0].price),
    quantity: Number(historicLine.quantity),
  };
}
function mapHistoryOrderToState(historicOrder, currencyRatio) {
  return {
    ...historicOrder,
    comment: historicOrder.comment,
    payment: historicOrder.payment,
    currency: historicOrder.currency,
    docToSend: historicOrder.docToSend,
    invoiceForTransport: historicOrder.invoiceForTransport,
    proposalTime: historicOrder.proposalTime,
    prepayment: historicOrder.prepayment,
    shippingCity: historicOrder.shippingCity,
    referenceNumber: historicOrder.referenceNumber,
    requiredTransport: historicOrder.requiredTransport,
    salesOrderReal: historicOrder.salesOrderReal,
    specialOrder: historicOrder.specialOrder,
    shippingValue: historicOrder.shippingValue,
  };
}

export function calculateLinePrice(line) {
  let price = line.product.price;
  return price * line.quantity;
}
export function calculateOptionPrice(price, option) {
  return option === 2 ? (price * 1.3).toFixed(2) : price;
}
export function calculateDiscount(price, discount, line) {
  if (line.option === 2) {
    return (price * 1.3 - price * (discount * 0.01)).toFixed(2);
  }
  return (price - price * discount * 0.01).toFixed(2);
}

export default {
  namespaced: true,
  state: {
    order: {
      lines: [],
      customer: {},
      type: "salesOrder",
      currency: "PLN",
      language: "pl",
      status: "open",
      shipping: {},
      shippingValue: "",
      payment: "",
      comment: "",
      proposalTime: "",
      requiredTransport: "",
      invoiceForTransport: "",
      specialOrder: "0",
      specialAddressForm: "N",
      referenceNumber: "",
      salesOrderReal: "",
      docToSend: "",
      prepayment: "0",
      shippingCity: "",
      docRate: "",
      addressForm: {
        city: "",
        street: "",
        country: "",
        zipCode: "",
        phone: "",
        email: "",
        codeGRS: "",
        nameGRS: "",
        addressName: "",
      },
    },
  },
  getters: {
    status: (state) => state.order.status,
    type: (state) => state.order.type,
    language: (state) => state.order.language,
    payment: (state) => state.order.payment,
    specialOrder: (state) => state.order.specialOrder,
    specialAddressForm: (state) => state.order.specialAddressForm,
    docToSend: (state) => state.order.docToSend,
    city: (state) => state.order.addressForm.city,
    street: (state) => state.order.addressForm.street,
    country: (state) => state.order.addressForm.country,
    phone: (state) => state.order.addressForm.phone,
    zipCode: (state) => state.order.addressForm.zipCode,
    codeGRS: (state) => state.order.addressForm.codeGRS,
    nameGRS: (state) => state.order.addressForm.nameGRS,
    addressName: (state) => state.order.addressForm.addressName,
    email: (state) => state.order.addressForm.email,
    salesOrderReal: (state) => state.order.salesOrderReal,
    itemCount: (state) => {
      return state.order.lines.length > 0 ? state.order.lines.length : 0;
      // return  state.order.lines.reduce((total, line) => total + line.quantity, 0);
    },
    totalPrice: (state) => {
      let summary = state.order.lines.reduce(
        (total, line) => total + calculateLinePrice(line),
        0,
        state.order.shippingValue
      );
      return summary;
    },
    //transport: state => state.order.shippingValue,
    currentCustomer: (state) => state.order.customer,
    currentShipping: (state) => state.order.shipping,
    currentAddressForm: (state) => state.order.addressForm,
  },
  mutations: {
    setSpecialOrder(state, value) {
      state.order.specialOrder = value;
    },
    setSpecialAddressForm(state, value) {
      state.order.specialAddressForm = value;
    },
    setStatus(state, value) {
      state.order.status = value;
    },
    setType(state, value) {
      state.order.type = value;
    },
    setReferenceNumber(state, value) {
      state.order.referenceNumber = value;
    },
    setTransportRequired(state, value) {
      state.order.requiredTransport = value;
    },
    setInvoiceForTransport(state, value) {
      state.order.invoiceForTransport = value;
    },
    setLanguageOrder(state, language) {
      console.log("languaga" + language);
      state.order.language = language;
    },
    setSearchTerm(state, term) {
      state.searchTerm = term;
      state.currentPage = 1;
    },
    selectOrderType(state, value) {
      console.log(" typ" + value);
      state.order.type = value;
    },
    selectOrderStatus(state, value) {
      console.log(" status" + value);
      state.order.status = value;
    },
    setSalesOrderReal(state, value) {
      state.order.salesOrderReal = value;
    },
    setDocToSend(state, value) {
      state.order.docToSend = value;
    },
    selectCustomer(state, currentCustomer) {
      state.order.customer = currentCustomer;
      Vue.notify({
        group: "success",
        title: "Kontrahent wybrany",
        text: currentCustomer.company,
      });
    },
    addHistoricOrder(state, { orderData, currencyRatio }) {
      Vue.set(
        state.order,
        "lines",
        orderData.products.map((line) =>
          mapHistoricLineIntoOrderLine(line, currencyRatio)
        )
      );
    },
    addProduct(state, { product, currencyRatio }) {
      let exist = ETollList.find(function(element) {
        return element.sku == product.sku ? true : false;
      });
      let findProduct = state.order.lines.find(
        (p) => p.product.id === product.id
      );
      if (findProduct && exist == null) {
        findProduct.quantity = 1;
        findProduct.status = "O";
      } else {
        let calculatedPrice =
          parseFloat(product.priceAfterDiscount) !== parseFloat(product.price)
            ? product.priceAfterDiscount
            : product.price;
        state.order.lines.push({
          id: Date.now(),
          product: {
            ...product,
            price: (calculatedPrice / currencyRatio).toFixed(2),
            name:
              state.order.currency === "PLN"
                ? product.name
                : product.descriptionEn,
          },
          basePrice: product.price,
          plnPrice: product.price,
          quantity: product.quantity || 1,
          quantityToTransport: product.quantityToTransport || 0,
          quantityToBlocked: product.quantityToBlocked || 0,
          etollDateFrom: product.etollDateFrom || null,
          etollEmai: product.etollEmai || null,
          sample: "N",
          status: "O",
        });
      }
    },
    addReorder(state, { orderHistory, currencyRatio }) {
      console.log(orderHistory);

      orderHistory.reorder.lines.forEach((line) => {
        let productReorder = {
          line: line,
          product: line.product[0],
        };
        let exist = ETollList.find(function(element) {
          return element.sku == productReorder.product.sku ? true : false;
        });
        let findProduct = state.order.lines.find(
          (p) => p.product.id === productReorder.product.id
        );
        if (findProduct && exist == null) {
          findProduct.quantity++;
        } else {
          let calculatedPrice = parseInt(
            productReorder.product.priceAfterDiscount
          )
            ? productReorder.product.priceAfterDiscount
            : productReorder.product.price;
          state.order.lines.push({
            id: Date.now() + productReorder.product.id,
            product: {
              ...productReorder.product,
              price: (calculatedPrice / currencyRatio).toFixed(2),
              name:
                state.order.currency === "PLN"
                  ? productReorder.product.name
                  : productReorder.product.descriptionEn,
            },
            basePrice: productReorder.line.basePrice,
            plnPrice: productReorder.line.plnPrice,
            quantity: productReorder.line.quantity || 1,
            quantityToTransport: productReorder.line.quantityToTransport || 0,
            quantityToBlocked: productReorder.line.quantityToBlocked || 0,
            etollDateFrom: productReorder.line.etollDateFrom || null,
            etollEmai: productReorder.line.etollEmai || null,
            quantitySended: productReorder.line.quantitySended || 0,
            statusLine: productReorder.line.statusLine || "none",
            baseLine: productReorder.line.baseLine || "",
            sample: productReorder.line.sample || "N",
            edit: true,
            status: "O",
          });
        }
      });
      const language = state.order.language;
      const newLines = state.order.lines;
      const customer = state.order.customer;
      const currentShipping = customer.shipping.find(
        (shipping) =>
          shipping.addressName === orderHistory.reorder.shippingAddress
      );
      delete orderHistory.reorder.lines;
      let rerderInfo = mapHistoryOrderToState(
        orderHistory.reorder,
        currencyRatio
      );
      Vue.set(state, "order", rerderInfo);
      Vue.set(state.order, "lines", newLines);
      Vue.set(state.order, "customer", customer);
      Vue.set(state.order, "shipping", currentShipping);
      state.order.type = orderHistory.type;
      state.order.status = orderHistory.mode;
      state.order.language = language;
    },
    changeQuantity(state, update) {
      updateLineInArray(state.order.lines, update.line, {
        quantity: update.change,
      });
    },
    changeQuantity(state, update) {
      updateLineInArray(state.order.lines, update.line, {
        quantity: update.change,
      });
    },
    changeQuantityToBlocked(state, update) {
      updateLineInArray(state.order.lines, update.line, {
        quantityToBlocked: update.change,
      });
    },
    changeEtollEmai(state, update) {
      updateLineInArray(state.order.lines, update.line, {
        etollEmai: update.change,
      });
    },
    changeEtollDateFrom(state, update) {
      updateLineInArray(state.order.lines, update.line, {
        etollDateFrom: update.change,
      });
    },
    changeStatusLine(state, update) {
      updateLineInArray(state.order.lines, update.line, {
        status: "C",
      });
    },
    changeQuantityToTransport(state, update) {
      updateLineInArray(state.order.lines, update.line, {
        quantityToTransport: update.change,
      });
    },
    changeSampleInfo(state, update) {
      if (update.change == "Y") {
        updateLineInArray(state.order.lines, update.line, {
          sample: update.change,
          product: {
            ...update.line.product,
            price: 0.1,
          },
        });
      } else if (update.change == "N" && update.line.edit) {
        updateLineInArray(state.order.lines, update.line, {
          sample: update.change,
          product: {
            ...update.line.product,
            price: update.line.plnPrice,
          },
        });
      } else {
        updateLineInArray(state.order.lines, update.line, {
          sample: update.change,
          product: {
            ...update.line.product,
            price: update.line.product.priceAfterDiscount,
          },
        });
      }
    },
    changeDescription(state, update) {
      if (update.change.lang === "pl") {
        updateLineInArray(state.order.lines, update.line, {
          product: {
            ...update.line.product,
            name: update.change.value,
          },
        });
      } else {
        updateLineInArray(state.order.lines, update.line, {
          product: {
            ...update.line.product,
            descriptionEn: update.change.value,
          },
        });
      }
    },
    changePrice(state, { change, ratio, line, leaveDiscount = false }) {
      updateLineInArray(state.order.lines, line, {
        discount: leaveDiscount ? line.discount : 0,
        product: {
          ...line.product,
          price: change,
        },
      });
      if (ratio) {
        updateLineInArray(state.order.lines, line, {
          plnPrice: change * ratio,
        });
      }
    },
    removeProduct(state, lineToRemove) {
      let index = state.order.lines.findIndex((line) => line === lineToRemove);
      if (index > -1) {
        state.order.lines.splice(index, 1);
      }
    },
    setCleanCart(state) {
      state.order.customer = {};
      state.order.shipping = {};
      state.order.addressForm = {};
      (state.order.specialAddressForm = "N"),
        (state.order.currency = "PLN"),
        (state.order.shippingValue = ""),
        (state.order.payment = ""),
        (state.order.comment = ""),
        (state.order.proposalTime = ""),
        (state.order.prepayment = ""),
        (state.order.shippingCity = ""),
        (state.order.docRate = ""),
        (state.order.requiredTransport = ""),
        (state.order.invoiceForTransport = ""),
        (state.order.specialOrder = "0"),
        (state.order.referenceNumber = ""),
        (state.order.salesOrderReal = ""),
        (state.order.docToSend = ""),
        (state.order.docRate = "");
      //state.order.language = "pl"
    },
    setCartData(state, data) {
      state.order.lines = data;
    },
    setCustomerData(state, data) {
      state.order.customer = data;
    },
    clearPages(state) {
      state.pages.splice(0, state.pages.length);
    },
    setPayment(state, value) {
      state.order.payment = value;
    },
    setShipping(state, value) {
      state.order.shipping = value;
    },
    setShippingValue(state, value) {
      state.order.shippingValue = value;
    },
    setProposalTime(state, value) {
      state.order.proposalTime = value;
    },
    setPrepayment(state, value) {
      state.order.prepayment = value;
    },
    setShippingCity(state, value) {
      state.order.shippingCity = value;
    },
    setDocRate(state, value) {
      state.order.docRate = value;
    },
    setComment(state, value) {
      state.order.comment = value;
    },
    SET_CITY(state, value) {
      state.order.addressForm.city = value;
    },
    SET_STREET(state, value) {
      state.order.addressForm.street = value;
    },
    SET_ZIPCODE(state, value) {
      state.order.addressForm.zipCode = value;
    },
    SET_EMAIL(state, value) {
      state.order.addressForm.email = value;
    },
    SET_PHONE(state, value) {
      state.order.addressForm.phone = value;
    },
    SET_ADDRESS_NAME(state, value) {
      state.order.addressForm.addressName = value;
    },
    SET_CODE_GRS(state, value) {
      state.order.addressForm.codeGRS = value;
    },
    SET_NAME_GRS(state, value) {
      state.order.addressForm.nameGRS = value;
    },
    SET_COUNTRY(state, value) {
      state.order.addressForm.country = value;
    },
  },
  actions: {
    setCity({ commit }, city) {
      commit("SET_CITY", city);
    },
    setCountry({ commit }, country) {
      commit("SET_COUNTRY", country);
    },
    setNameGrs({ commit }, nameGrs) {
      commit("SET_NAME_GRS", nameGrs);
    },
    setCodeGrs({ commit }, codeGrs) {
      commit("SET_CODE_GRS", codeGrs);
    },
    setStreet({ commit }, street) {
      commit("SET_STREET", street);
    },
    setZipCode({ commit }, zipCode) {
      commit("SET_ZIPCODE", zipCode);
    },
    setPhone({ commit }, phone) {
      commit("SET_PHONE", phone);
    },
    setEmail({ commit }, email) {
      commit("SET_EMAIL", email);
    },
    setAddressName({ commit }, addressName) {
      commit("SET_ADDRESS_NAME", addressName);
    },
    backCustomer(context) {
      return context.rootState.cart.order.customer.customer.customerId;
    },
    checkCustomerExist(context) {
      if (!context.rootState.cart.order.customer.customer) {
        Vue.notify({
          group: "error",
          type: "error",
          title: "Wybierz kontrahenta",
          text: "Musisz wybrać kontrahenta przed dodaniem dokumentu",
        });
      }
    },
    addProduct(context, product) {
      context.commit("addProduct", {
        product,
        localization: context.rootState.auth.user.localization,
        currencyRatio: context.rootState.currency.ratio,
      });
    },
    addReorder(context, order) {
      console.log(order);
      context.commit("addReorder", {
        orderHistory: order,
        currencyRatio: context.rootState.currency.ratio,
      });
    },
    reorder(context, orderData) {
      context.commit("addHistoricOrder", {
        orderData,
        currencyRatio: context.rootState.currency.ratio,
      });
    },
    loadCartData(context) {
      let data = localStorage.getItem("cart");
      if (data !== "undefined" && data !== null) {
        context.commit("setCartData", JSON.parse(data));
      }
    },
    storeCartData(context) {
      localStorage.setItem("cart", JSON.stringify(context.state.order.lines));
      localStorage.setItem(
        "customer",
        JSON.stringify(context.state.order.customer)
      );
    },
    clearCartData(context) {
      context.commit("setCartData", []);
      context.commit("setCustomerData", {});
      localStorage.removeItem("cart");
      localStorage.removeItem("customer");
    },
    initializeCart(context, store) {
      context.dispatch("loadCartData");
      store.watch(
        (state) => state.cart.order.lines,
        () => context.dispatch("storeCartData"),
        { deep: true }
      );
    },
    initilizeAddressForm(context, store) {
      debugger;
      context.commit("SET_CITY", "");
      context.commit("SET_STREET", "");
      context.commit("SET_ADDRESS_NAME", "");
      context.commit("SET_ZIPCODE", "");
      context.commit("SET_COUNTRY", "");
      context.commit("SET_PHONE", "");
      context.commit("SET_CODE_GRS", "");
      context.commit("SET_NAME_GRS", "");
      context.commit("SET_EMAIL", "");
    },
    initializeCustomer(context, store) {
      context.dispatch("loadCartData");
      store.watch(
        (state) => state.cart.order.customer,
        () => context.dispatch("storeCartData"),
        { deep: true }
      );
    },
    search(context, term) {
      context.commit("setSearchTerm", term);
      context.commit("clearPages");
      context.dispatch("getPage", 2);
    },
  },
};
